﻿const normalize = (value: unknown, fallback: number, min: number) => {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }
  const parsed = Math.trunc(Number(value));
  return Number.isFinite(parsed) ? Math.max(min, parsed) : fallback;
}

/** Normalizes a page index from any source (state, sessionStorage, query string) to a usable value >= 0. */
export const clampPage = (page?: unknown) => normalize(page, 0, 0);

/** Normalizes a page size from any source to a usable value >= 1, falling back when absent or non-numeric. */
export const clampSize = (size?: unknown, fallback: number = 10) => normalize(size, fallback, 1);

export const getUrlSearchParamsByPaging = (page?: number, size?: number) => {
  return new URLSearchParams({page: String(clampPage(page)), size: String(clampSize(size))})
}
